$(document).ready(function() {

  $('.quantity-input').on('change', function() {
    console.log('changed');
    setTimeout(() => {
      get_cart_details();
      console.log('inner-click');
    }, 500);
  });

  $('button[type="submit"]').on('click', (function(e) {
    setTimeout(() => {
      $.getJSON('/cart.js', function(cart){
        if (cart.items.length === 0) return;

        let first_free_product = true;
        let second_free_product = true;

        // from cart data
        let items = cart.items;
        let cart_total = cart.total_price / 100.0;
        console.log(cart_total);
        
        // from theme settings schema
        let first_product_id = 44140126765356;
        let second_product_id = 44140500058412;
        let first_product_amount = 60;
        let second_product_amount = 100;

        items.map((item,i) => {
          if (item.variant_id == first_product_id) 
          {
            first_free_product = false;
            console.log('first pro false');
          }
          else if(item.variant_id == second_product_id) 
          {
            second_free_product = false;
            console.log('second pro false');
          }
        });

        if ((first_free_product && cart_total >= first_product_amount) || (second_free_product && cart_total >= second_product_amount)) {

          let productsToAdd;
          if( first_free_product && second_free_product && cart_total >= second_product_amount ) {
            productsToAdd = [
              { id: first_product_id, quantity: 1 }, // Product 1 ID and quantity
              { id: second_product_id, quantity: 1 }, // Product 2 ID and quantity
            ];
          }
          else if( first_free_product && cart_total >= first_product_amount ) {
            productsToAdd = [
              { id: first_product_id, quantity: 1 } // Product 1 ID and quantity
            ];
          }
          else if( second_free_product && cart_total >= second_product_amount ) {
            productsToAdd = [
              { id: second_product_id, quantity: 1 } // Product 1 ID and quantity
            ];
          }

          var data = {
            items: productsToAdd
          };

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(result) {
              console.log("Products added");
              get_cart_details();
            },
            error: function(err) {
              console.log(err);
            }
          });
        } 
        else {
          console.log("Product already added!");
        }

        // let items = cart.items;
        // items = items.map((item,i) => {
        //   return {
        //     position: i,
        //     id: item.variant_id,
        //     sku: item.sku,
        //     productId: item.product_id,
        //     variantId: item.variant_id,
        //     name: item.product_title.replace("'", ''),
        //     quantity: item.quantity,
        //     price: item.price / 100,
        //     brand: item.vendor.replace("'", ''),
        //     variant: item.variant_title
        //   }
        // })
    
        // open cart drawer
      });
    }, 1000);
  }));

  function get_cart_details() {
    $.getJSON('/cart.js', function(cart){
      // header item update
      $('.header__cart-count .count-bubble').text(cart.item_count);
      setTimeout(()=> {
        $('.cart-drawer__top .count-bubble').text(cart.item_count);
      }, 500)
    });

    update_cart_drawer();
  }

  function update_cart_drawer() {
    fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(cartData => {
      var mini_cart_updated_html = $(cartData);

      var cart_drawer_top = $('.cart-drawer__top', mini_cart_updated_html);
      var cart_items_updated = $('.cart-drawer__line-items', mini_cart_updated_html); // here we updated the cart area from updated mini_cart_updated_html
      var cart_price_updated = $('.cart-drawer__total-price', mini_cart_updated_html);

      $('.cart-drawer__top').replaceWith(cart_drawer_top);
      $('.cart-drawer__line-items').replaceWith(cart_items_updated);
      $('.cart-drawer__total-price').replaceWith(cart_price_updated);
    });
  }
});

